import * as React from 'react';
import {Svg, G, Path, Defs, ClipPath} from 'react-native-svg';

const Logo = props => {
  return (
    <Svg
      width={39}
      height={46}
      viewBox="0 0 39 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G clipPath="url(#clip0_1811_25280)">
        <Path
          d="M15.654 12.204l-7.998-4.67-7.084 4.139V33.97l7.995 4.67V16.345l7.087-4.14zM19.66.523l-7.998 4.67 19.088 11.15v8.281l7.996-4.673v-8.279L19.66.523z"
          fill="#2B2E75"
        />
        <Path
          d="M38.746 24.632L19.66 35.778l-7.087-4.14v9.344l7.087 4.14L38.746 33.97v-9.338z"
          fill="#4AA6E1"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1811_25280">
          <Path
            fill="#fff"
            transform="translate(.572 .523)"
            d="M0 0H38.0952V44.5993H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default Logo;
